import { LitElement, html, css } from 'lit';
import { jhaStyles } from '../styles/jha-styles.js';

const styles = css`
  :host {
    display: inline-block;
    position: relative;
  }
  :host::before {
    position: absolute;
    z-index: 1061;
    width: 0;
    height: 0;
    color: var(
      --jha-tooltip-color-background,
      var(--jha-color-dark, rgba(39, 45, 51, 0.8))
    );
    pointer-events: none;
    content: '';
    border: 5px solid transparent;
  }
  :host::after {
    position: absolute;
    z-index: 1060;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 400;
    font-style: normal;
    color: var(--jha-tooltip-text-color, var(--jha-text-white, #ffffff));
    line-height: 1.5;
    text-align: left;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: break-word;
    max-width: 160px;
    width: max-content;
    pointer-events: none;
    content: attr(text);
    background-color: var(
      --jha-tooltip-color-background,
      var(--jha-color-dark, rgba(39, 45, 51, 0.8))
    );
    border-radius: 3px;
    -webkit-font-rendering: subpixel-antialised;
  }
  :host::before,
  :host::after {
    visibility: hidden;
    opacity: 0;
    transition: opacity cubic-bezier(0.1, 0.5, 0.1, 1) 0.3s;
  }
  :host([visible])::before,
  :host(:hover)::before,
  :host(:active)::before,
  :host(:focus)::before,
  :host([visible])::after,
  :host(:hover)::after,
  :host(:active)::after,
  :host(:focus)::after {
    visibility: visible;
    opacity: 1;
    text-decoration: none;
  }
  :host([bottom])::after,
  :host([bottom-right])::after,
  :host([bottom-left])::after {
    top: var(--jha-tooltip-bottom-after-top, 100%);
    right: var(--jha-tooltip-bottom-after-right, 50%);
    margin-top: 5px;
  }
  :host([bottom])::before,
  :host([bottom-right])::before,
  :host([bottom-left])::before {
    top: var(--jha-tooltip-bottom-before-top, auto);
    right: var(--jha-tooltip-bottom-before-right, 50%);
    bottom: -5px;
    margin-right: -5px;
    border-bottom-color: rgba(39, 45, 51, 0.8);
  }
  :host([bottom-right])::after {
    right: var(--jha-tooltip-bottom-right-after-right, auto);
    left: var(--jha-tooltip-bottom-right-after-left, 50%);
    margin-left: -15px;
  }
  :host([bottom-left])::after {
    margin-right: -15px;
  }
  :host([top])::after,
  :host([top-right])::after,
  :host([top-left])::after {
    right: var(--jha-tooltip-top-after-right, 50%);
    bottom: var(--jha-tooltip-top-after-bottom, 100%);
    margin-bottom: 5px;
  }
  :host([top])::before,
  :host([top-right])::before,
  :host([top-left])::before {
    top: var(--jha-tooltip-top-before-top, -5px);
    right: var(--jha-tooltip-top-before-right, 50%);
    bottom: var(--jha-tooltip-top-before-bottom, auto);
    margin-right: -5px;
    border-top-color: var(
      --jha-tooltip-color-background,
      var(--jha-color-dark, rgba(39, 45, 51, 0.8))
    );
  }
  :host([top-right])::after {
    right: var(--jha-tooltip-top-right-after-right, auto);
    left: var(--jha-tooltip-top-right-after-left, 50%);
    margin-left: -15px;
  }
  :host([top-left])::after {
    margin-right: -15px;
  }
  :host([bottom])::after,
  :host([top])::after {
    transform: translateX(50%);
  }
  :host([left])::after {
    right: var(--jha-tooltip-left-after-right, 100%);
    bottom: var(--jha-tooltip-left-after-bottom, 50%);
    margin-right: 5px;
    transform: translateY(50%);
  }
  :host([left])::before {
    top: var(--jha-tooltip-left-before-top, 50%);
    bottom: var(--jha-tooltip-left-before-bottom, 50%);
    left: var(--jha-tooltip-left-before-left, -5px);
    margin-top: -5px;
    border-left-color: rgba(39, 45, 51, 0.8);
  }
  :host([right])::after {
    bottom: var(--jha-tooltip-right-after-bottom, 50%);
    left: var(--jha-tooltip-right-after-left, 100%);
    margin-left: 5px;
    transform: translateY(50%);
  }
  :host([right])::before {
    top: var(--jha-tooltip-right-before-top, 50%);
    right: var(--jha-tooltip-right-before-right, -5px);
    bottom: var(--jha-tooltip-right-before-bottom, 50%);
    margin-top: -5px;
    border-right-color: var(
      --jha-tooltip-right-before-border,
      rgba(39, 45, 51, 0.8)
    );
    border-top-color: var(--jha-tooltip-right-before-top-border, transparent);
  }
  :host([avatar])::after {
    bottom: 5px;
    left: 100%;
    margin-left: 10px;
    transform: translateY(50%);
  }
  :host([avatar])::before {
    top: auto;
    right: -10px;
    bottom: 0;
    margin-top: -5px;
    border-right-color: rgba(39, 45, 51, 0.8);
  }
  :host([avatar-list-item]) {
    display: inline;
  }
  :host([avatar-list-item])::after {
    bottom: -30px;
    left: 100%;
    margin-left: 0;
    transform: translateY(50%);
  }
  :host([avatar-list-item])::before {
    top: auto;
    right: 0;
    bottom: -35px;
    margin-top: -5px;
    border-right-color: rgba(39, 45, 51, 0.8);
  }
  :host([avatar-user-profile])::after {
    bottom: 15px;
    left: 100%;
    margin-left: 10px;
    transform: translateY(50%);
  }
  :host([avatar-user-profile])::before {
    top: auto;
    right: -10px;
    bottom: 10px;
    margin-top: -5px;
    border-right-color: rgba(39, 45, 51, 0.8);
  }
`;

/**
 * JHA Tooltip
 * Adds helper text displayed when the slotted item is hovered over
 *
 * @element jha-tooltip
 *
 * @prop {string} text - the message to be displayed
 * @prop {boolean} visible - programmatically added when the slotted content is hovered over
 *
 * @slot unnamed slot for the content to hover over
 *
 * @cssprop --jha-tooltip-color-background - color of the tooltips background
 * @cssprop --jha-tooltip-text-color - the text color of the message
 */
export default class JhaTooltip extends LitElement {
  static get styles() {
    return [jhaStyles, styles];
  }

  static get properties() {
    return {
      text: {
        type: String,
      },
      visible: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  constructor() {
    super();
    this.text = '';
    this.visible = false;
  }

  onFocus() {
    this.visible = true;
  }

  onBlur() {
    this.visible = false;
  }

  connectedCallback() {
    super.connectedCallback();
    // this.addEventListener('focus', this.boundOnFocus = this.onFocus.bind(this));
    // this.addEventListener('blur', this.boundOnBlur = this.onBlur.bind(this));
    Promise.resolve().then(() => {
      let innerElement = this.querySelector('a, button');
      const jhaElement = this.querySelector('jha-button, jha-link-button');

      if (!innerElement && jhaElement) {
        innerElement = jhaElement.shadowRoot.querySelector('a, button');
      }

      if (innerElement) {
        innerElement.addEventListener(
          'focus',
          (this.boundOnFocus = this.onFocus)
        );
        innerElement.addEventListener('blur', (this.boundOnBlur = this.onBlur));
      }
    });
  }

  render() {
    return html`
      <span text=${this.text}>
        <slot></slot>
      </span>
    `;
  }
}

export { styles as JhaTooltipStyles };
